import './Navigation.css';
import { Link } from 'react-router-dom';

const Navigation = () => {
  const blueStarLogo = 'https://assets.bluestar-rowing.com/assets/logos/blue_star_logo.png';

  return (
    <nav style={{
      position: 'fixed',
      top: '30px',
      left: 0,
      right: 0,
      zIndex: 1000,
      backgroundColor: 'transparent',
      backdropFilter: 'none'
    }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 40px' }}>
        <div style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '64px'
        }}>
          {/* Logo */}
          <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img
              src={blueStarLogo}
              alt="Blue Star Rowing Logo"
              className="nav-logo"
              style={{
                width: '300px',
                height: '300px',
                objectFit: 'contain'
              }}
            />
          </Link>

          {/* Desktop Navigation */}
          <div style={{
            display: 'none',
            alignItems: 'center',
            gap: '32px'
          }} className="desktop-nav">
          </div>

          {/* CTA Button & Mobile Menu */}
          <div className="nav-cta-group" style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <Link
              to="/our-purpose"
              style={{
              background: '#0F1C2D',
              color: 'white',
              padding: '6px 16px',
              borderRadius: '20px',
              border: '1px solid white',
              fontWeight: '400',
              cursor: 'pointer',
              fontSize: '12px',
              letterSpacing: '0.05em',
              transition: 'all 0.2s',
              textDecoration: 'none',
              display: 'inline-block'
            }} className="purpose-btn"
            onMouseOver={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = 'black';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#0F1C2D';
              e.target.style.color = 'white';
            }}
            onMouseDown={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = 'black';
            }}
            onMouseUp={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = 'black';
            }}>
              Our Purpose
            </Link>
            <Link
              to="/corporate-sponsorship"
              style={{
              background: '#0F1C2D',
              color: 'white',
              padding: '6px 16px',
              borderRadius: '20px',
              border: '1px solid white',
              fontWeight: '400',
              cursor: 'pointer',
              fontSize: '12px',
              letterSpacing: '0.05em',
              transition: 'all 0.2s',
              textDecoration: 'none',
              display: 'inline-block'
            }} className="corporate-sponsorship-btn"
            onMouseOver={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = 'black';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#0F1C2D';
              e.target.style.color = 'white';
            }}
            onMouseDown={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = 'black';
            }}
            onMouseUp={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = 'black';
            }}>
              Corporate Sponsorship
            </Link>
            <button
              onClick={() => window.open('https://www.gofundme.com/f/blue-star-atlantic-row-2026', '_blank')}
              style={{
              background: '#0F1C2D',
              color: 'white',
              padding: '6px 16px',
              borderRadius: '20px',
              border: '1px solid white',
              fontWeight: '400',
              cursor: 'pointer',
              fontSize: '12px',
              letterSpacing: '0.05em',
              transition: 'all 0.2s'
            }} className="join-btn"
            onMouseOver={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = 'black';
            }}
            onMouseOut={(e) => {
              e.target.style.backgroundColor = '#0F1C2D';
              e.target.style.color = 'white';
            }}
            onMouseDown={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = 'black';
            }}
            onMouseUp={(e) => {
              e.target.style.backgroundColor = 'white';
              e.target.style.color = 'black';
            }}>
              Personal Donation
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
